module.exports = __webpack_public_path__ + "img/main.b4ba4ef6.jpg";